import { Component, Input, ElementRef, Renderer2, ViewEncapsulation, ViewChild, OnChanges, PLATFORM_ID, Inject } from '@angular/core';

@Component({
  selector: 'n7-preload-image',
  templateUrl: './n7-preload-image.component.html',
  styleUrls: [
    './n7-preload-image.component.scss'
  ],
  encapsulation: ViewEncapsulation.None
})
export class N7PreloadImageComponent implements OnChanges {
  _src = '';
  _ratio: { w: number, h: number };
  itemBackground = '#0e0e0e';
  itemShowSpinner = true;

  constructor(
    private _elementRef: ElementRef,
    private _renderer: Renderer2
  ) {}

  @Input() set src(val: string) {
    this._src = (val !== undefined && val !== null) ? val : '';
  }

  @Input() set ratio(ratio: { w: number, h: number }) {
    this._ratio = ratio || {w: 1, h: 1};
  }

  @Input() set background(val: string) {
    this.itemBackground = (val !== undefined && val !== null) ? val : '#0e0e0e';
  }

  @Input() set showSpinner(val: boolean) {
    this.itemShowSpinner = (val !== undefined && val !== null) ? val : true;
  }

  ngOnChanges() {
    const ratio_height = (this._ratio.h / this._ratio.w * 100) + '%';
    // Conserve aspect ratio (see: https://stackoverflow.com/a/10441480/1116959)
    this._renderer.setStyle(this._elementRef.nativeElement, 'padding', '0px 0px ' + ratio_height + ' 0px');
    this._renderer.setStyle(this._elementRef.nativeElement, 'background-color', this.itemBackground);
    this._update();
  }

  _update() {
    this._loaded(false);
  }

  _loaded(isLoaded: boolean) {
    if (isLoaded) {
      setTimeout(() => {
        this._renderer.addClass(this._elementRef.nativeElement, 'img-loaded');
      }, 500);
    } else {
      this._renderer.removeClass(this._elementRef.nativeElement, 'img-loaded');
    }
  }
}
